import { ButtonProps as SiteCoreButtonProps } from '@alliander-fe/sitecore-types';
import { ButtonProps } from '@ads-core/types';
import { Button, ButtonLink } from '@ads-core/components';

type CongestionButtonProps = {
  handleOnClick: (anchor: 'congestion' | 'conclusion') => void;
} & SiteCoreButtonProps &
  Pick<ButtonProps, 'variant'>;

// Checks if the button has an anchor, and maps it so we can scroll to the correct section.
// Otherwise we just render a Button link.
export const CongestionButton = ({
  handleOnClick,
  variant,
  text,
  ...button
}: CongestionButtonProps) => {
  if (!text) return null;
  const anchor =
    button.anchor === 'congestion' || button.anchor === 'conclusion' ? button.anchor : null;

  return anchor ? (
    <Button variant={variant} onClick={() => handleOnClick(anchor)}>
      {text}
    </Button>
  ) : (
    <ButtonLink {...button} variant={variant}>
      {text}
    </ButtonLink>
  );
};

